import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

// attach token if exists
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("hc_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Strip empty-string fields from JSON bodies — Pydantic optional validators choke on ""
api.interceptors.request.use((cfg) => {
  if (cfg.data && typeof cfg.data === "object" && !(cfg.data instanceof FormData)) {
    cfg.data = Object.fromEntries(
      Object.entries(cfg.data).filter(([, v]) => v !== "" && v !== undefined)
    );
  }
  return cfg;
});

// Format FastAPI validation errors into readable strings so React never receives an object
export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((x) => (typeof x === "string" ? x : x?.msg || JSON.stringify(x))).join(", ");
  }
  return fallback;
}

export default api;
